import { render } from "./ProjectAcusto.vue?vue&type=template&id=cdc433a8"
import script from "./ProjectAcusto.vue?vue&type=script&lang=js"
export * from "./ProjectAcusto.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__